export default __webpack_public_path__ + "static/media/msat-instr-test-card-1.e506d10f.svg";